var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "noFeedback" },
    _vm._l(_vm.feedbackNoInfoList, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "bg-FF p-24 m-t-20 feedbackReceivedList" },
        [
          _c(
            "div",
            { staticClass: "m-b-24 feedbackReceivedListName flex row-left" },
            [
              _c("img", {
                staticClass: "w-40 h-42 m-r-16",
                attrs: {
                  src: require("@/assets/icon/feedbackStatistics/user.png"),
                  alt: "人员",
                },
              }),
              _c("div", { staticClass: "userName font-32 text-left" }, [
                _vm._v(_vm._s(item.nickName)),
              ]),
            ]
          ),
          _c("div", { staticClass: "cor-99 flex font-28 row-between" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex row-between m-b-16 itemBoxBg p-8 b-r-10 w-280 m-r-16",
              },
              [
                _vm._m(0, true),
                _vm._v(" 正常考勤: "),
                _c("span", { staticClass: "cor-66" }, [
                  _vm._v(_vm._s(item.kqNum) + "天"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex row-between m-b-16 itemBoxBg p-8 b-r-10 flex-1",
              },
              [
                _vm._m(1, true),
                _vm._v(" 未反馈: "),
                _c("span", { staticClass: "cor-66" }, [
                  _vm._v(
                    _vm._s(item.notFeedbackNum) +
                      "(请假" +
                      _vm._s(item.leaveDays) +
                      "天)"
                  ),
                ]),
              ]
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-38 h-40 m-r-8" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          src: require("@/assets/icon/feedbackStatistics/attendanceRecordIcon.png"),
          alt: "人员",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-38 h-40 m-r-8" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          src: require("@/assets/icon/feedbackStatistics/noFeedbackIcon.png"),
          alt: "人员",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }